<template>
  <b-tabs content-class="my-4" nav-wrapper-class="switching-tabs">
    <b-tab :title="'Notifications ('+Object.keys(notifications).length+')'" active>
      <ul v-for="(singleNotifications, notificationIndex) in notifications" :key="notificationIndex" class="notification-list">
        <!-- {{ singleNotifications }} -->

        <!-- <li v-for="(item, index) in notifications[notificationIndex]" :key="index">
          {{ item }}
        </li> -->
        <li v-for="(item, index) in notifications[notificationIndex]" :key="index">
          <div v-if="index == 0" class="col-12 pb-3">
            <span class="notification-date">{{item.Date}}</span>
          </div>
          <div class="col-12 col-md-10 d-flex align-items-center">
            <div>
              <img :src="item.notificationImage" class="pr-3 notificationImage">
            </div>
            <div  v-html="item.Message"></div>
          </div>
          <div class="col-12 col-sm-12 col-md-2 d-flex align-items-center justify-content-md-end ">
            <div class="text-right ml-auto">
              <span>{{item.Time}}</span>
              
            </div>
          </div>
        </li>

        <!-- <li>
          <div class="col-12 col-md-10 d-flex align-items-center px-0">
            <img src="@/assets/img/svg/icon-error.svg" class="pr-2" height="45px" width="45px">
            Your Event for ‘Gifted Hands’ created for September 05, 2018, 11.30PM at Capital Theatre just got confirmed!
          </div>
          <div class="col-12 col-sm-12 col-md-2 d-flex align-items-center justify-content-md-end">
            <div class="text-muted">
              <span>September</span>
              <span>|</span>
              <span>1:30 PM</span>
            </div>
          </div>
        </li>

        <li>
          <div class="col-12 col-md-10 d-flex align-items-center px-0">
            <img src="@/assets/img/svg/icon-delay.svg" class="pr-2" height="45px" width="45px">
            Your Event for ‘Gifted Hands’ created for September 05, 2018, 11.30PM at Capital Theatre just got confirmed!
          </div>
          <div class="col-12 col-sm-12 col-md-2 d-flex align-items-center justify-content-md-end">
            <div class="text-muted">
              <span>September</span>
              <span>|</span>
              <span>1:30 PM</span>
            </div>
          </div>
        </li>

         <li>
          <div class="col-12 col-md-10 d-flex align-items-center px-0">
            <img src="@/assets/img/svg/icon-credit.svg" class="pr-2" height="45px" width="45px">
            Your Event for ‘Gifted Hands’ created for September 05, 2018, 11.30PM at Capital Theatre just got confirmed!
          </div>
          <div class="col-12 col-sm-12 col-md-2 d-flex align-items-center justify-content-md-end">
            <div class="text-muted">
              <span>September</span>
              <span>|</span>
              <span>1:30 PM</span>
            </div>
          </div>
        </li> -->


      </ul>

    </b-tab>


    <!-- <b-tab title="Read (0)">

      <div>No Notification</div>
      <ul v-if="singleNotifications.isRead == 1" v-for="(singleNotifications, notificationIndex) in notifications" :key="notificationIndex" class="notification-list">
        <li>
          <div class="col-12 col-md-10 px-0" v-html="singleNotifications.Message">
            <img src="@/assets/img/svg/icon-tick.svg" class="pr-2" height="40px" width="40px">
          </div>
          <div class="col-12 col-sm-12 col-md-2 d-flex align-items-center justify-content-md-end">
            <div class="text-muted">
              <span>{{singleNotifications.Date}}</span>
            
          </div>
        </li>
        </ul>
    </b-tab> -->
  </b-tabs>
</template>

<script>
import { makeRequest } from "@/helper/internet.js";
import { TokenService } from "@/services/storage.service";
import _ from "lodash";
export default {
  data() {
    return {
      obj:{
        name: "here",
        name1: "here",
        name1: "here",
      },
      notifications: {}
    };
  },
  beforeMount() {
    this.fetchNotifications();
  },
  methods: {
    fetchNotifications: function() {
      let token = TokenService.getToken();
      makeRequest("/GetNotificationsList", "POST", token, null)
        .then(result => {
          // this.notifications = result.res.data.List;
          this.notifications = _.groupBy(result.res.data.List,'Date');
          console.log('this.notifications :', this.notifications);
        })
        .catch(error => {
          console.log("Error", error);
        });
    }
  }
};
</script>

<style>
.notification-list {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
  border-bottom: 2px solid #8d99af61;
}

.notification-icon {
  height: auto;
  width: auto;
}

.notification-list li {
  display: flex;
  flex-wrap: wrap;
  padding: 15px 0;
  border-bottom: 1px solid #8d99af61;
}
.notification-date {
  font-size: 14px;
  font-weight: bold;
  color: #2b2d42;
}
.notificationImage{
  min-width: 50px;
  height: auto;
  max-width: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/myNotification.vue